// NOTE: These types are based on the CSS class definitions in _alerts.scss
export enum AlertInlineTypes {
  info = 'info',
  warning = 'warning',
  danger = 'danger',
  success = 'success',
  primary = 'primary',
}
